import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { forwardRef, useCallback, useMemo } from "react";

import { useDynamicColumnDefs } from "../../../../_src_shared/utils/agGrid/hooks/useDynamicColumnDefs";
import { formatPhone } from "../../../../_src_shared/utils/functions/formatPhone";
import AgGridClickableTable from "../../../../components/agGrid/tables/AgGridClickableTable";
import Flx from "../../../../components/layout/Flx";
import Txt from "../../../../components/typography/Txt";
import { isFunction } from "lodash";
import { columnTypesDate } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesBoolean } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesBoolean";
import { agApiAutoSizeColumns } from "../../../../_src_shared/utils/agGrid/api/agApiAutoSizeColumns";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper";
import { AgGridReact } from "ag-grid-react";
import { agApiSizeColumnsToFit } from "../../../../_src_shared/utils/agGrid/api/agApiSizeColumnsToFit";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const LoanContactsTable = forwardRef(
  (
    {
      rowData,
      onRowClicked,

      quickFilterText,
    },
    ref
  ) => {
    const columnDefs = useMemo(() => {
      return [
        {
          headerName: "Name",
          field: "firstName",
          flex: 1,
          minWidth: 200,
          cellClass: null,
          cellStyle: { paddingTop: "8px", paddingBottom: "8px" },
          autoHeight: true,
          valueFormatter: (params) => {
            return ` ${params.data?.firstName} ${params.data?.lastName}`;
          },

          cellRenderer: (params) => {
            return (
              <Flx column>
                <Txt>
                  {params.data?.firstName} {params.data?.lastName}
                </Txt>
                <Txt secondary>{params.data?.loanRole}</Txt>
              </Flx>
            );
          },
        },
        {
          field: "company",
        },
        {
          field: "loanRole",
        },
        {
          field: "appraiserLicenseNumber",
        },
        {
          headerName: "Phone",
          field: "phone",
          valueFormatter: (params) => {
            return formatPhone(params.value);
          },
        },
        {
          field: "emailAddress",
        },

        {
          headerName: "Created Date",
          field: "createDateTime",
          type: "date",
        },
        {
          field: "profileComplete",
          type: "boolean",
        },
      ];
    }, []);

    const dynamicColumnDefs = useDynamicColumnDefs(rowData, columnDefs);

    const handleOnRowClicked = useCallback(
      (params) => {
        if (isFunction(onRowClicked)) onRowClicked(params?.data);
      },
      [onRowClicked]
    );

    const defaultColDef = useMemo(
      () => ({
        filter: true,
        suppressHeaderFilterButton: true,
        suppressHeaderMenuButton: true,
        // menuTabs: ["filterMenuTab"],
        // minWidth: 110,

        // flex: 1,
        cellClass: "ag-cell-vertical-center",
        // cellClass: "ag-cell-vertical-center",
      }),
      []
    );

    const columnTypes = useMemo(
      () => ({
        ...columnTypesDate(),
        ...columnTypesBoolean(),
        // ...columnTypesDollar(),
        // ...columnTypesPercent(),
      }),
      []
    );

    const onFirstDataRendered = useCallback((params) => {
      agApiSizeColumnsToFit(params);
      // agApiAutoSizeColumns(params);
    }, []);

    return (
      <AgGridTableWrapper
        suppressMinHeightWhenPopulated={rowData}
        // height={height}
        simpleTable
        sx={{ minWidth: "340px" }}
      >
        <AgGridReact
          ref={ref}
          rowData={rowData}
          columnDefs={dynamicColumnDefs}
          defaultColDef={defaultColDef}
          quickFilterText={quickFilterText}
          onFirstDataRendered={onFirstDataRendered}
          columnTypes={columnTypes}
          domLayout={"autoHeight"}
          onRowClicked={handleOnRowClicked}
          //   detailCellRendererParams={{ refreshStrategy: "rows" }}
          //   detailRowAutoHeight={true}
        />
      </AgGridTableWrapper>
    );

    // return (
    //   <>
    //     <AgGridClickableTable
    //       ref={ref}
    //       rowData={rowData}
    //       simpleTable={simpleTable}
    //       columnDefs={dynamicColumnDefs}
    //       quickFilterText={quickFilterText}
    //       // selectedId={selectedId}
    //       path="contacts"
    //       autoSizeToFit
    //       onRowClicked={onRowClicked}
    //     />

    //     {masterDetail}
    //   </>
    // );
  }
);

export default LoanContactsTable;
